export enum ListTypeEnum {
  WHITE_LIST = 'White list',
  BLACK_LIST = 'Black list',
}
